import React, { useContext } from 'react'
import { Link } from 'react-router-dom'
import { store } from '../../components/HOC/State'
import { BACKEND_URL } from '../../const/Constant'
import styles from './product.module.css'
import { translate } from '../translate'

export default function ProductItem({el, page}) {
  const  {selectedLang} = useContext(store)
  let lang = translate[selectedLang]
  const id = el._id
  return (
    <div className={styles['products-item-1']} style={{padding: page ? "15px 0" : "15px"}}>
          <div className={styles['products-image-div-1']}>
              <img src={BACKEND_URL + el.image} alt='element-image'/>
          </div>
          <div className={styles['products-information-1']}>
              <p className={styles['products-title-1']}>{el[`${selectedLang}name`]}</p>
              <p className={styles['products-description-1']}>{el[`${selectedLang}description`]}</p>
              <div className={styles['download']}>
                {el.linkofdownload && <a href={BACKEND_URL + el.linkofdownload} download target='_blank' ><button className={styles['see-more']}>{lang.tr_download}</button></a>}
                {!page && <Link to={`/products/${id}`}><button className={styles['see-more']}>{lang.tr_more}</button></Link>}
		{el.video && <a href={el.video} target='_blank' ><button className={styles['see-more']}>Youtube</button></a>}
              </div>
          </div>
      </div>
  )
}
